import * as React from 'react'
import Icon from '@mui/icons-material/Group'
// import { useGetIdentity } from 'react-admin';

// import { UserCreate } from './create';
// import { TeamMemberEdit } from './edit';
import { TeamMemberList } from './list'
// import { UserShow } from './show';
import { ComponentWithSubheader } from 'dash/shared'

export default class Team {
  static Icon = Icon
  // static Create = UserCreate;
  // static Edit = (props) => {
  //   const { identity, loading: identityLoading } = useGetIdentity();

  //   if (identityLoading) return null;

  //   const {
  //     user: { id: userId },
  //   } = identity;

  //   let path: string[];
  //   let label: string;

  //   if (props.id == userId) {
  //     path = ['My Profile'];
  //     label = 'Preferences';
  //   } else {
  //     path = ['My Account', 'Team'];
  //     label = 'Edit User';
  //   }

  //   return <ComponentWithSubheader path={path} label={label} component={TeamMemberEdit} {...props} />;
  // };
  static List = () => <ComponentWithSubheader path={['My Account']} label="Team" component={TeamMemberList} />
  // static Show = UserShow;
}
